import React from 'react';
import {Dropdown, Menu, Switch} from 'antd';
import {connect, useDispatch} from 'react-redux';
import {signOut} from 'redux/actions/Auth';
import {onHeaderNavColorChange, onSwitchAndSaveTheme, onSwitchTheme,} from '../../redux/actions/Theme';
import {useThemeSwitcher} from 'react-css-theme-switcher';
import {Link} from 'react-router-dom';
import ProfileIcon from 'components/icons/Profile';
import SettingsIcon from 'components/icons/Settings';
import BillingIcon from 'components/icons/Billing';
import LogoutIcon from 'components/icons/Logout';
import OpenBookIcon from 'components/icons/OpenBook';
import CustomAvatar from "../util-components/Avatar";
import {UsergroupAddOutlined} from "@ant-design/icons";

const menuItem = [
  {
    title: 'Profile',
    Icon: ProfileIcon,
    path: '/app/profile',
  },
  {
    title: 'Settings',
    Icon: SettingsIcon,
    path: '/app/settings',
  },
  {
    title: 'Users',
    Icon: UsergroupAddOutlined,
    path: '/app/settings/users',
  },
  {
    title: 'Billing',
    Icon: BillingIcon,
    path: '/app/billing',
  },
  {
    title: 'Documentation',
    Icon: OpenBookIcon,
    path: '/docs',
  },
];

export const NavProfile = (props) => {
  const dispatch = useDispatch();
  const { currentTheme, onHeaderNavColorChange, onSwitchAndSaveTheme, user } =
    props;

  const { switcher, themes } = useThemeSwitcher();

  const toggleTheme = () => {
    onHeaderNavColorChange('');
    const changedTheme = currentTheme === 'dark' ? 'light' : 'dark';

    console.log(`Switching from ${currentTheme} to ${changedTheme}`);

    onSwitchAndSaveTheme(changedTheme);
    switcher({ theme: themes[changedTheme] });
  };

  // const onSignOut = () => {
  // 	signOut(history);
  // };

  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <Link
                  to={el.path}
                  className="d-flex flex-row align-items-center gap-1"
                >
                  <el.Icon />
                  <span className="font-weight-normal">{el.title}</span>
                </Link>
              </Menu.Item>
            );
          })}

          <Menu.Item
            key={menuItem.length + 1}
            className="d-flex flex-row align-items-center gap-1"
          >
            <Switch checked={currentTheme === 'dark'} onChange={toggleTheme} />
            <span className="font-weight-normal">Dark Mode</span>
          </Menu.Item>

          <Menu.Divider />

          <Menu.Item
            icon={<LogoutIcon />}
            className="logout-menu-item"
            onClick={() => dispatch(signOut())}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              color: 'red',
            }}
          >
            <span className="font-weight-normal">Logout</span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={['click']}>
      <Menu
        className="d-flex align-items-center walkthrough-custom-profile"
        mode="horizontal"
      >
        <Menu.Item className="d-flex flex-row align-items-center justify-content-center gap-1">
          <CustomAvatar
            name={user.name}
            size={40}
            email={user.email}
          />
          <span className="font-weight-bold">{user?.name}</span>
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
};

const mapStateToProps = ({ theme, auth }) => {
  const mappedState = {
    ...theme,
    user: auth.user,
  };
  return mappedState;
};

const mapDispatchToProps = {
  signOut,
  onSwitchAndSaveTheme,
  onSwitchTheme,
  onHeaderNavColorChange,
};

export default connect(mapStateToProps, mapDispatchToProps)(NavProfile);
